export const POST_GLOBAL_MESSAGE = "POST_GLOBAL_MESSAGE";
